// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-a0d850cc]{cursor:pointer}.visible-content[data-v-a0d850cc]{border-left:4px solid #187cc6}.collapse[data-v-a0d850cc]{padding-left:20px}.scrollable-dd[data-v-a0d850cc] .dropdown-menu{max-height:300px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
